import { Route, Routes } from 'react-router-dom';

import PackageExplorerForm from './PackageExplorerForm';
import PackageExplorerTable from './PackageExplorerTable';

const PackageExplorerView = () => {
  return (
    <Routes>
      <Route path="/" element={<PackageExplorerTable />} />
      <Route path="/form" element={<PackageExplorerForm />} />
    </Routes>
  );
};

export default PackageExplorerView;
